import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36ac17d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = {
  class: "nge-shotdlg",
  role: "dialog",
  "aria-label": "Save screenshot"
}
const _hoisted_3 = { class: "nge-shotdlg-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined nge-shotdlg-ico" }, "photo_camera", -1 /* HOISTED */))
const _hoisted_5 = { class: "nge-shotdlg-body" }
const _hoisted_6 = { class: "nge-shotdlg-preview-wrap" }
const _hoisted_7 = { class: "nge-shotdlg-pen" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-shotdlg-pen-label" }, "Pen", -1 /* HOISTED */))
const _hoisted_9 = { class: "nge-shotdlg-swatches" }
const _hoisted_10 = ["onClick", "title"]
const _hoisted_11 = ["title"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "15",
  height: "15",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M9 14l-4-4 4-4" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M5 10h9a5 5 0 0 1 0 10h-3" })
], -1 /* HOISTED */))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "15",
  height: "15",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M3 6h18" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M8 6V4h8v2" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M6 6l1 14h10l1-14" })
], -1 /* HOISTED */))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "nge-shotdlg-row" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-shotdlg-label" }, "Width", -1 /* HOISTED */))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-shotdlg-times" }, "×", -1 /* HOISTED */))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-shotdlg-label" }, "Height", -1 /* HOISTED */))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-shotdlg-px" }, "px", -1 /* HOISTED */))
const _hoisted_21 = { class: "nge-shotdlg-presets" }
const _hoisted_22 = { class: "nge-shotdlg-checks" }
const _hoisted_23 = { class: "nge-shotdlg-check" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Transparent background", -1 /* HOISTED */))
const _hoisted_25 = { class: "nge-shotdlg-check" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Hide volume edge / bounding box", -1 /* HOISTED */))
const _hoisted_27 = { class: "nge-shotdlg-check" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Show scale bar", -1 /* HOISTED */))
const _hoisted_29 = {
  key: 0,
  class: "nge-shotdlg-err"
}
const _hoisted_30 = { class: "nge-shotdlg-actions" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($props.show)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "nge-shotdlg-overlay",
        onClick: _withModifiers($setup.close, ["self"])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("span", null, _toDisplayString($setup.props.mode === 'attach' ? 'Attach screenshot' : 'Save screenshot'), 1 /* TEXT */),
            _createElementVNode("button", {
              class: "nge-shotdlg-close",
              onClick: $setup.close,
              "aria-label": "Close"
            }, "×")
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("canvas", {
                ref: "previewEl",
                class: "nge-shotdlg-preview",
                width: $setup.PREVIEW_W,
                height: $setup.PREVIEW_H
              }, null, 512 /* NEED_PATCH */),
              _createElementVNode("canvas", {
                ref: "markupEl",
                class: "nge-shotdlg-markup",
                width: $setup.PREVIEW_W,
                height: $setup.PREVIEW_H,
                onPointerdown: $setup.onPointerDown,
                onPointermove: $setup.onPointerMove,
                onPointerup: $setup.onPointerUp,
                onPointercancel: $setup.onPointerUp
              }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.PEN_COLORS, (c) => {
                  return _createElementVNode("button", {
                    key: c,
                    class: _normalizeClass(["nge-shotdlg-swatch", { 'is-active': $setup.penColor === c }]),
                    style: _normalizeStyle({ background: c }),
                    onClick: $event => ($setup.penColor = c),
                    title: c
                  }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_10)
                }), 64 /* STABLE_FRAGMENT */))
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                min: "1",
                max: "12",
                step: "1",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.penSize) = $event)),
                class: "nge-shotdlg-pen-size",
                title: `Brush size: ${$setup.penSize}px`
              }, null, 8 /* PROPS */, _hoisted_11), [
                [
                  _vModelText,
                  $setup.penSize,
                  void 0,
                  { number: true }
                ]
              ]),
              _createElementVNode("button", {
                class: "nge-shotdlg-pen-btn",
                onClick: $setup.undo,
                title: "Undo last stroke"
              }, _hoisted_13),
              _createElementVNode("button", {
                class: "nge-shotdlg-pen-btn",
                onClick: $setup.clearMarkup,
                title: "Clear all marks"
              }, _hoisted_15)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _withDirectives(_createElementVNode("input", {
                type: "number",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.width) = $event)),
                min: "16",
                max: "8192"
              }, null, 512 /* NEED_PATCH */), [
                [
                  _vModelText,
                  $setup.width,
                  void 0,
                  { number: true }
                ]
              ]),
              _hoisted_18,
              _hoisted_19,
              _withDirectives(_createElementVNode("input", {
                type: "number",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.height) = $event)),
                min: "16",
                max: "8192"
              }, null, 512 /* NEED_PATCH */), [
                [
                  _vModelText,
                  $setup.height,
                  void 0,
                  { number: true }
                ]
              ]),
              _hoisted_20
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = $event => ($setup.preset(1280, 720)))
              }, "720p"),
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = $event => ($setup.preset(1920, 1080)))
              }, "1080p"),
              _createElementVNode("button", {
                onClick: _cache[5] || (_cache[5] = $event => ($setup.preset(2560, 1440)))
              }, "1440p"),
              _createElementVNode("button", {
                onClick: _cache[6] || (_cache[6] = $event => ($setup.preset(3840, 2160)))
              }, "4K")
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("label", _hoisted_23, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($setup.transparent) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, $setup.transparent]
                ]),
                _hoisted_24
              ]),
              _createElementVNode("label", _hoisted_25, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (($setup.hideBoundingBox) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, $setup.hideBoundingBox]
                ]),
                _hoisted_26
              ]),
              _createElementVNode("label", _hoisted_27, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => (($setup.showScaleBar) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, $setup.showScaleBar]
                ]),
                _hoisted_28
              ])
            ]),
            ($setup.errorMsg)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString($setup.errorMsg), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("button", {
              class: "nge-shotdlg-cancel",
              onClick: $setup.close,
              disabled: $setup.busy
            }, "Cancel", 8 /* PROPS */, _hoisted_31),
            _createElementVNode("button", {
              class: "nge-shotdlg-primary",
              onClick: $setup.download,
              disabled: $setup.busy
            }, _toDisplayString($setup.busy
              ? ($setup.props.mode === 'attach' ? 'Uploading…' : 'Rendering…')
              : ($setup.props.mode === 'attach' ? 'Attach' : 'Download')), 9 /* TEXT, PROPS */, _hoisted_32)
          ])
        ])
      ], 8 /* PROPS */, _hoisted_1))
    : _createCommentVNode("v-if", true)
}